var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"title":'スカウト件数調査'}}),_vm._v(" "),_c('div',{staticClass:"boss-admin-container clearfix",staticStyle:{"margin-left":"-170px"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }